import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-toastify";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";

const BrandDeleteModal = ({
  brand,
  refetch,
  setShowBrandDeleteModal,
  setModalData,
}) => {
  const [user, userLoading] = useAuthState(auth);
  const { _id, brand_name, brand_slug } = brand;

  if (userLoading) {
    return <Loading></Loading>;
  }

  const handleDeleteBrand = () => {
    fetch(`https://evening-peak-35730.herokuapp.com/brand/${_id}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data) {
          fetch(
            `https://evening-peak-35730.herokuapp.com/products/${brand_slug}`,
            {
              method: "DELETE",
              headers: {
                "content-type": "application/json",
              },
            }
          )
            .then((res) => {
              return res.json();
            })
            .then((data) => {
              // console.log(data);
              const updateTotalDataStatus = {
                status: "decreaseBrands",
                deletedProductCount: data?.deletedCount,
              };
              fetch(
                `https://evening-peak-35730.herokuapp.com/updateTotalProductsAndBrands/${user?.email}`,
                {
                  method: "PUT",
                  headers: {
                    "content-type": "application/json",
                    authorization: `Bearer ${localStorage.getItem(
                      "accessToken"
                    )}`,
                  },
                  body: JSON.stringify(updateTotalDataStatus),
                }
              )
                .then((res2) => {
                  return res2.json();
                })
                .then((data2) => {
                  setModalData({});
                  setShowBrandDeleteModal(false);
                  refetch();
                  toast.success(
                    "Brand And Products deleted successfully. Alhamdulillah!!"
                  );
                });
            });
        }
      });
  };
  return (
    <div>
      <input type="checkbox" id="my-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-xl text-error">
            Are you sure to delete {brand_name}!!
          </h3>
          <div className="py-4 font-bold text-primary">
            <p>Brand's Name = {brand_name}</p>
            <p>Brand's Slug = {brand_slug}</p>
          </div>
          <div className="modal-action">
            <label for="my-modal" className="btn btn-primary">
              No
            </label>
            <label
              onClick={handleDeleteBrand}
              className="btn btn-error text-white font-bold"
            >
              Yes
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDeleteModal;
